import { cn } from '@/lib/cn'

function Skeleton({
  className,
  ...props
}: React.HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      className={cn('rounded-md bg-surface-muted animate-skeleton', className)}
      {...props}
    />
  )
}

export { Skeleton }
